/* DG10 PLUS — mejoras de conversión. Complementa dg10.js sin reemplazarlo. */
(function(){
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var SIZE_ORDER = ['XXS','XS','S','P','M','L','XL','XXL','XXXL','2XL','3XL'];

  function ready(fn){ if(document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function(){
    var drawer = document.querySelector('[data-cart-drawer]');
    var activePill = document.querySelector('.catalog-inline-nav .is-active');
    if(activePill && activePill.parentNode.scrollWidth > activePill.parentNode.clientWidth){ activePill.parentNode.scrollLeft = activePill.offsetLeft - 20; }
    var lock = function(on){ document.body.style.overflow = on ? 'hidden' : ''; };

    /* ---------- Barra de anuncios: rota en celular ---------- */
    var announce = document.querySelector('[data-dg-announce]');
    if(announce){
      var items = announce.querySelectorAll('.dg-announce-item');
      if(items.length > 1){
        var idx = 0;
        setInterval(function(){
          if(window.matchMedia('(min-width: 990px)').matches) return;
          items[idx].classList.remove('is-active');
          idx = (idx + 1) % items.length;
          items[idx].classList.add('is-active');
        }, 3500);
      }
    }

    /* ---------- Carrito: refresca el panel con los productos reales ---------- */
    var refreshing = false;
    function refreshDrawer(addedTitle){
      if(!drawer || refreshing) return Promise.resolve();
      refreshing = true;
      return fetch(root + '?sections=cart-drawer', {headers:{Accept:'application/json'}})
        .then(function(r){ return r.json(); })
        .then(function(data){
          var html = data && data['cart-drawer'];
          if(!html) return;
          var tmp = document.createElement('div');
          tmp.innerHTML = html;
          var fresh = tmp.querySelector('.cart-panel');
          var current = drawer.querySelector('.cart-panel');
          if(fresh && current){
            current.innerHTML = fresh.innerHTML;
            if(addedTitle){
              var body = current.querySelector('[data-cart-body]');
              if(body){
                var note = document.createElement('p');
                note.className = 'dg-cart-added';
                note.textContent = '✓ Agregaste ' + addedTitle;
                body.insertBefore(note, body.firstChild);
              }
            }
            current.querySelectorAll('[data-cart-close]').forEach(function(el){
              el.addEventListener('click', function(){ drawer.setAttribute('aria-hidden','true'); lock(false); });
            });
          }
        })
        .catch(function(err){ console.error('DG10 drawer refresh', err); })
        .then(function(){ refreshing = false; });
    }

    // Cuando dg10.js muestra "Producto agregado", reemplazamos por el carrito real.
    if(drawer){
      var observer = new MutationObserver(function(){
        var body = drawer.querySelector('[data-cart-body]');
        if(body && body.querySelector('.cart-success')){
          var title = '';
          var h1 = document.querySelector('.product-details h1');
          if(h1 && document.body.classList.contains('template-product')) title = h1.textContent.trim();
          refreshDrawer(title);
        }
      });
      observer.observe(drawer, {childList:true, subtree:true});
    }

    /* ---------- Agregar por talle desde las tarjetas ---------- */
    document.addEventListener('click', function(e){
      var btn = e.target.closest('[data-dg-quick-add]');
      if(!btn || btn.disabled) return;
      e.preventDefault();
      btn.classList.add('is-loading');
      fetch(root + 'cart/add.js', {
        method:'POST',
        headers:{'Content-Type':'application/json', Accept:'application/json'},
        body: JSON.stringify({items:[{id:Number(btn.dataset.variantId), quantity:1}]})
      })
      .then(function(r){ if(!r.ok) return r.json().then(function(j){ throw new Error(j.description || 'Error'); }); return r.json(); })
      .then(function(){ return fetch(root + 'cart.js', {headers:{Accept:'application/json'}}).then(function(r){ return r.json(); }); })
      .then(function(cart){
        document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = cart.item_count; });
        btn.classList.remove('is-loading');
        btn.classList.add('is-added');
        setTimeout(function(){ btn.classList.remove('is-added'); }, 1400);
        var label = (btn.dataset.productTitle || '') + (btn.dataset.variantTitle ? ' (' + btn.dataset.variantTitle + ')' : '');
        return refreshDrawer(label).then(function(){
          if(drawer){ drawer.setAttribute('aria-hidden','false'); lock(true); }
        });
      })
      .catch(function(err){
        btn.classList.remove('is-loading');
        alertInline(btn, err.message);
      });
    });

    function alertInline(btn, msg){
      var wrap = btn.closest('.dg-quick-sizes') || btn.parentNode;
      var old = wrap.querySelector('.dg-quick-error');
      if(old) old.remove();
      var p = document.createElement('p');
      p.className = 'dg-quick-error';
      p.style.cssText = 'font-size:11px;color:#a33;margin:6px 0 0';
      p.textContent = msg || 'No se pudo agregar. Probá de nuevo.';
      wrap.appendChild(p);
      setTimeout(function(){ p.remove(); }, 3500);
    }

    /* ---------- Página de producto ---------- */
    var form = document.querySelector('[data-product-form]');
    if(form){
      // Talles en orden lógico (M, L, XL…)
      form.querySelectorAll('.option-values').forEach(function(group){
        var labels = Array.prototype.slice.call(group.querySelectorAll('.option-value'));
        var rank = function(l){
          var v = (l.querySelector('input').value || '').toUpperCase().trim();
          var i = SIZE_ORDER.indexOf(v);
          return i === -1 ? 99 : i;
        };
        if(labels.some(function(l){ return rank(l) !== 99; })){
          labels.sort(function(a,b){ return rank(a) - rank(b); }).forEach(function(l){ group.appendChild(l); });
        }
      });

      // Precio y talle elegido al cambiar variante
      var variantsEl = document.querySelector('[data-product-variants]');
      var variants = [];
      try{ variants = JSON.parse(variantsEl ? variantsEl.textContent : '[]'); }catch(err){}
      var priceEl = document.querySelector('[data-dg-price]');
      var stickyPrice = document.querySelector('[data-dg-sticky-price]');
      var stickyBtn = document.querySelector('[data-dg-sticky-button]');
      var money = function(cents){
        try{ return new Intl.NumberFormat('es-UY',{style:'currency',currency:(window.Shopify && Shopify.currency && Shopify.currency.active) || 'UYU',minimumFractionDigits:2}).format(cents/100).replace('UYU','$').replace(/\s/g,''); }
        catch(err){ return '$' + (cents/100).toFixed(2); }
      };
      var sync = function(){
        form.querySelectorAll('input[data-option-position]:checked').forEach(function(input){
          var cur = form.querySelector('[data-dg-option-current="' + input.dataset.optionPosition + '"]');
          if(cur) cur.textContent = input.value;
        });
        var idInput = form.querySelector('[data-variant-id]');
        var v = variants.find(function(x){ return String(x.id) === String(idInput && idInput.value); });
        if(v){
          if(priceEl) priceEl.textContent = money(v.price);
          if(stickyPrice) stickyPrice.textContent = money(v.price);
          if(stickyBtn){ stickyBtn.disabled = !v.available; stickyBtn.textContent = v.available ? 'AGREGAR' : 'AGOTADO'; }
        }
      };
      form.addEventListener('change', function(){ setTimeout(sync, 0); });
      setTimeout(sync, 0);

      // Barra fija en celular: aparece cuando el botón principal sale de pantalla
      var mainBtn = form.querySelector('.product-submit');
      var sticky = document.querySelector('[data-dg-sticky-atc]');
      if(mainBtn && sticky && 'IntersectionObserver' in window){
        var footer = document.querySelector('.site-footer');
        var mainVisible = true, footerVisible = false;
        var update = function(){
          var show = !mainVisible && !footerVisible && window.scrollY > 200;
          document.body.classList.toggle('dg-sticky-on', show);
          sticky.setAttribute('aria-hidden', String(!show));
        };
        new IntersectionObserver(function(entries){ mainVisible = entries[0].isIntersecting; update(); }).observe(mainBtn);
        if(footer) new IntersectionObserver(function(entries){ footerVisible = entries[0].isIntersecting; update(); }).observe(footer);
        if(stickyBtn){
          stickyBtn.addEventListener('click', function(){
            var hasOptions = form.querySelector('.option-group');
            if(hasOptions && !form.dataset.dgChosen){
              // Si hay talles, llevamos al selector para que elija primero
              hasOptions.scrollIntoView({behavior:'smooth', block:'center'});
              hasOptions.classList.add('dg-flash');
              setTimeout(function(){ hasOptions.classList.remove('dg-flash'); }, 1200);
              form.dataset.dgChosen = '1';
              return;
            }
            mainBtn.click();
          });
        }
        form.addEventListener('change', function(){ form.dataset.dgChosen = '1'; });
      }

      // Contador de fotos en la galería (celular)
      var counter = document.querySelector('[data-dg-gallery-count]');
      var gallery = document.querySelector('[data-product-gallery]');
      if(counter && gallery){
        var slides = gallery.querySelectorAll('[data-gallery-slide]');
        new MutationObserver(function(){
          var active = 0;
          slides.forEach(function(s, i){ if(!s.hidden) active = i; });
          counter.textContent = (active + 1) + ' / ' + slides.length;
        }).observe(gallery, {attributes:true, subtree:true, attributeFilter:['hidden']});
      }
    }
  });
})();
